module.exports = __webpack_public_path__ + "img/fullLogo.59f6b6d9.png";